module.exports = __webpack_public_path__ + "static/index/assets/img/logo.fd2050af.png";